export enum NotificationType {
  FlowComment = 1,
  FlowModelFeedback = 2,
  StepTaskComment = 3,
  FlowModelPublished = 4
}
